// // index.js
// import React from 'react';
// import ReactDOM from 'react-dom/client';

// import './styles/GlobalStyles.js';
// import { FirebaseProvider } from './contexts/FirebaseContext.js';
// import App from './App.js';

// import './styles/variables.css';
// import './styles/global.css';


// import GlobalStyles from './styles/GlobalStyles';


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>

//       <App />
   
//   </React.StrictMode>
// );


import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/variables.css';
import './styles/global.css';

import GlobalStyles from './styles/GlobalStyles'; // If you are using styled-components
import { FirebaseProvider } from './contexts/FirebaseContext.js';
import App from './App.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FirebaseProvider>
      <GlobalStyles /> {/* ✅ Apply global styles here */}
      <App />
    </FirebaseProvider>
  </React.StrictMode>
);

